import type { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { useSession } from '@/core/auth/hooks/useSession'

type GuestGuardProps = PropsWithChildren

/**
 * Protects guest-only routes (login, register).
 * Redirects to /dashboard if the user is already authenticated.
 */
export function GuestGuard({ children }: GuestGuardProps) {
  const { status, isAuthenticated } = useSession()

  if (status === 'loading') return null

  if (isAuthenticated) {
    return <Navigate replace to="/dashboard" />
  }

  return <>{children}</>
}
